const JSON_LITERAL_PAYLOADS = Object.freeze(['true', 'false', 'null']);

function has_json_wrapper(value = '') {
  const first_character = value.charAt(0);
  const last_character = value.charAt(value.length - 1);
  return (
    (first_character === '{' && last_character === '}')
    || (first_character === '[' && last_character === ']')
  );
}

function is_json_like_payload(value = '') {
  const normalized = value.trim();
  return has_json_wrapper(normalized) || JSON_LITERAL_PAYLOADS.includes(normalized);
}

export function parse_api_data(payload) {
  if (typeof payload === 'string' && is_json_like_payload(payload)) {
    return JSON.parse(payload);
  }

  return payload;
}

function normalize_message(value) {
  if (value === null || value === undefined) {
    return '';
  }

  if (Array.isArray(value)) {
    return value.map(normalize_message).filter(Boolean).join(', ');
  }

  if (typeof value === 'object') {
    return Object.entries(value)
      .map(([key, entry]) => {
        const message = normalize_message(entry);
        return message ? `${key}: ${message}` : '';
      })
      .filter(Boolean)
      .join(', ');
  }

  return String(value).trim();
}

export function get_api_response_message(payload, fallback_message = 'Something went wrong. Please try again.') {
  const data = parse_api_data(payload);

  if (!data || typeof data !== 'object') {
    return normalize_message(data) || fallback_message;
  }

  const message_candidates = [
    data.message,
    data.detail,
    data.error,
    data.errors,
    data.details,
    data.non_field_errors,
  ];
  const direct_message = normalize_message(message_candidates.find(Boolean));

  if (direct_message) {
    return direct_message;
  }

  const nested_message = normalize_message(data.data);
  return nested_message || fallback_message;
}

export function get_api_error_message(error, fallback_message = 'Something went wrong. Please try again.') {
  return get_api_response_message(error?.response?.data, error?.message || fallback_message);
}
